var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.54102,
    y: 6.5,
    width: 27,
    height: 27,
    stroke: "#737478",
    strokeDasharray: "5 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.54102,
    y: 30.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.541,
    y: 30.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.54102,
    y: 4.5,
    width: 5,
    height: 5,
    fill: "white",
    stroke: "#2C3038"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_927_23524)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.743,
    height: 12.4936,
    transform: "translate(22.041 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_927_23524",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.041 6C28.9411 6 34.5346 11.5936 34.5346 18.4936V20.9923H22.041V6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.041 3.50128H22.041C30.3211 3.50128 37.0334 10.2136 37.0334 18.4936H32.0359C32.0359 12.9736 27.561 8.49872 22.041 8.49872H22.041V3.50128ZM34.5346 20.9923H22.041H34.5346ZM22.041 20.9923V6V20.9923ZM22.041 3.50128C30.3211 3.50128 37.0334 10.2136 37.0334 18.4936V20.9923H32.0359V18.4936C32.0359 12.9736 27.561 8.49872 22.041 8.49872L22.041 3.50128Z",
    fill: "#F87B0E",
    mask: "url(#path-5-inside-1_927_23524)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_927_23524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.743,
    height: 12.4936,
    fill: "white",
    transform: "translate(22.041 6)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/round.a30ab7fe6d6ae85dfa99000d4d7f6c22.svg";